import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createSlots as _createSlots, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  style: {"text-align":"right","margin-bottom":"20px"}
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("新增联系人")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("男")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("女")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("停用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取消")

import { reactive, ref, unref, watch } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';

/* 组件 */
import moment from 'moment';
import { GbTables } from '@/components/GbTables';
import { useGbTable } from '@/hooks/useGbTable'
import { GbDialog } from '@/components/GbDialog/Index';

/* Helpers */
import { propTypes } from '@/utils/propTypes';

/* Apis */
import { CpContactListApi, CpContactDelApi, CpContactEdtApi, CpContactInsApi, CpContactInfoApi } from '@/apis/counterpart_contact/cp.contact.api';

/* Types */
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { CpContactItem } from '@/apis/counterpart_contact/cp.contact.type';
import { CpContactSearch, CpContactBase, CpContactEdt } from '@/apis/counterpart_contact/cp.contact.type';


export default /*#__PURE__*/_defineComponent({
  props: {
    cpId: propTypes.string.def(''),
    privew: propTypes.bool.def(false),
},
  setup(__props, { expose }) {

const props = __props



/* GbTable 配置 */
const { register, tableObject, methods } = useGbTable<CpContactItem>({
    getListApi: CpContactListApi,
    delListApi: CpContactDelApi,
    response: { data: 'data', total: 'total' }
})

const { setSearchParams } = methods
const search = reactive<CpContactSearch>({
    current: 1,
    page_size: 10,
    counterpart_id: props.cpId
})

const isLoading = ref<boolean>(false)
const isCreate = ref<boolean>(false)
const showDialog = ref<boolean>(false)
const elFormRef = ref<ComponentRef<typeof ElForm>>()

/* 表单数据 */
const formSchema = ref<CpContactBase>({
    counterpart_id: props.cpId || '0',
    name: '',
    sex: '男',
    position: '',
    mobile: '',
    phone: '',
    remark: '',
    is_enabled: 'Y'
})

/* 数据Table绑定设置 */
const tabColumns = reactive<TableColumn[]>([
    { field: 'name', label: '姓名', columnWidth: "100" },
    { field: 'sex', label: '性别', columnWidth: "60" },
    { field: 'position', label: '职务', columnWidth: "200", align: "left" },
    { field: 'phone', label: '电话', columnWidth: "150", },
    { field: 'mobile', label: '手机', columnWidth: "150", },
    { field: 'remark', label: '备注', align: "left" },
    { field: 'is_enabled', label: '状态', columnWidth: "80", fixed: 'right' },
    { field: 'created_time', label: '创建时间', columnWidth: "120", fixed: 'right' },

])

if (!props.privew) {

    tabColumns.push({ field: 'action', width: '120px', label: "操作", fixed: 'right', align: 'center' })

}

/* 表单验证规则 */
const formRules = reactive<FormRules>({
    name: [
        { required: true, message: '联系人姓名不能为空', trigger: 'blur' },
    ],
    position: [
        { required: true, message: '联系人职务不能为空', trigger: 'blur' },
    ],
    // phone: [
    //     { required: true, message: '联系人电话不能为空', trigger: 'blur' },
    // ],
    mobile: [
        { required: true, message: '联系人手机不能为空', trigger: 'blur' },
    ],
})

/* 新增相对方 */
const onAddContactBtnClick = () => {
    showDialog.value = true
    isCreate.value = true

    const emptyVal = {
        name: '',
        sex: '男',
        position: '',
        mobile: '',
        phone: '',
        remark: '',
        is_enabled: 'Y'
    }

    formSchema.value = Object.assign({}, formSchema.value, emptyVal);
}

/* 点击修改按钮 */
const onEditBtnClick = (row: any) => {

    showDialog.value = true
    isCreate.value = false
    isLoading.value = true;

    CpContactInfoApi(row.id)
        .then((res) => {

            if (!res.succeeded) {
                ElMessage.error(`读取联系人信息出错！可能的原因：${res.errors}`)
            } else {
                formSchema.value = Object.assign({}, res.data)

            }
        })
        .finally(() => {
            isLoading.value = false
        });
}

/* 删除数据 */
const deleteAction = async (row: any) => {
    await methods.deleteRows(row);
}

const finishAcion = () => {
    isLoading.value = false
    showDialog.value = false

    if (props.cpId) {
        setSearchParams(search)
    }
}

/* 点击保存按钮 */
const onSaveBtnClick = (isCreate: boolean) => {

    /* 表单验证 */
    unref(elFormRef)?.validate((isValid: boolean) => {

        if (!isValid) return

        isLoading.value = true;

        if (isCreate) {

            /* 新建联系人 */
            CpContactInsApi(formSchema.value).then((res) => {

                if (!res.succeeded) {
                    ElMessage.error(`新建联系人出错！可能的原因：${res.errors}`)
                } else {
                    ElMessage.success(`操作成功`)

                    if (!props.cpId) {
                        tableObject.tableList.push(res.data)
                    }
                }

            }).finally(finishAcion)

        } else {

            const editData: CpContactEdt = Object.assign({}, formSchema.value) as CpContactEdt

            CpContactEdtApi(editData).then((res) => {

                if (!res.succeeded) {
                    ElMessage.error(`修改联系人出错！可能的原因：${res.errors}`)
                } else {
                    ElMessage.success(`操作成功`)
                }

            }).finally(finishAcion)
        }
    })
}

/* 需要暴露出去的属性&方法 */
const expMethods: {

    getContactList: () => Array<string>

} = {

    getContactList: () => {

        return tableObject.tableList.map((item: CpContactItem) => {
            return item.id
        })

    }
}

watch(() => props.cpId, (id) => {

    unref(search).counterpart_id = id

    setSearchParams(search)

    formSchema.value.counterpart_id = (id || '')

})

expose({ expMethods })

setSearchParams(search)

return (_ctx: any,_cache: any) => {
  const _component_ElButton = _resolveComponent("ElButton")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!props.privew)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ElButton, {
            type: "primary",
            onClick: onAddContactBtnClick
          }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(GbTables), {
      pageSize: _unref(tableObject).pageSize,
      "onUpdate:pageSize": _cache[0] || (_cache[0] = ($event: any) => ((_unref(tableObject).pageSize) = $event)),
      currentPage: _unref(tableObject).currentPage,
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_unref(tableObject).currentPage) = $event)),
      columns: _unref(tabColumns),
      data: _unref(tableObject).tableList,
      loading: _unref(tableObject).loading,
      pagination: { total: _unref(tableObject).total },
      selection: false,
      onRegister: _unref(register)
    }, _createSlots({
      created_time: _withCtx(({ row }) => [
        _createElementVNode("span", null, _toDisplayString(_unref(moment)(row.created_time).format("YYYY/MM/DD HH:mm")), 1)
      ]),
      is_enabled: _withCtx(({ row }) => [
        (row.is_enabled == 'N')
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              type: "danger"
            }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (row.is_enabled == 'Y')
          ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 1,
              type: "success"
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 2
    }, [
      (!props.privew)
        ? {
            name: "action",
            fn: _withCtx(({ row }) => [
              _createVNode(_component_ElButton, {
                type: "primary",
                link: "",
                onClick: ($event: any) => (onEditBtnClick(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_5
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_ElButton, {
                type: "danger",
                link: "",
                onClick: ($event: any) => (deleteAction(row))
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          }
        : undefined
    ]), 1032, ["pageSize", "currentPage", "columns", "data", "loading", "pagination", "onRegister"]),
    _withDirectives((_openBlock(), _createBlock(_unref(GbDialog), {
      modelValue: showDialog.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((showDialog).value = $event)),
      title: isCreate.value ? '新增联系人' : '修改联系人'
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[9] || (_cache[9] = ($event: any) => (onSaveBtnClick(isCreate.value)))
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "info",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_unref(ElForm), {
          ref_key: "elFormRef",
          ref: elFormRef,
          model: formSchema.value,
          "label-width": "120px",
          "label-position": 'right',
          rules: _unref(formRules),
          style: {"padding":"20px 40px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "联系人姓名",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: formSchema.value.name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.name) = $event)),
                  placeholder: "请录入姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "性别",
              prop: "sex"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formSchema.value.sex,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.sex) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "男" }, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: "女" }, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "联系人职务",
              prop: "position"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: formSchema.value.position,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.position) = $event)),
                  placeholder: "请录入联系人职务"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "手机",
              prop: "mobile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: formSchema.value.mobile,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.mobile) = $event)),
                  placeholder: "请录入联系人手机"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "电话",
              prop: "phone"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "text",
                  modelValue: formSchema.value.phone,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.phone) = $event)),
                  placeholder: "请录入联系人电话"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "备注",
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: formSchema.value.remark,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.remark) = $event)),
                  rows: "3",
                  "show-word-limit": "",
                  maxlength: "150"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "状态",
              prop: "is_enabled"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: formSchema.value.is_enabled,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_button, { label: "Y" }, {
                      default: _withCtx(() => [
                        _hoisted_9
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio_button, { label: "N" }, {
                      default: _withCtx(() => [
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])), [
      [_directive_loading, isLoading.value]
    ])
  ], 64))
}
}

})